// Dynamiczne ładowanie stylów i skryptów dla bloków
const contextStyles = require.context(
    '/template/blocks', // Ścieżka do katalogu bloków
    true,                // Przeszukuj podkatalogi
    /style\.scss$/       // Dopasowanie do plików style.scss
);

const contextFrontScripts = require.context(
    '/template/blocks',
    true,
    /front\.js$/ // Dopasowanie do plików front.js
);

// Ładowanie wszystkich znalezionych plików
contextStyles.keys().forEach(contextStyles);
contextFrontScripts.keys().forEach(contextFrontScripts);
